import { LeadProps, ProfileProps } from '@/types'

const isValidContact = (contact?: {
  name?: string
  email?: string
  phone?: string
}) => Boolean(contact?.name && contact?.email && contact?.phone)

export const checkIfGeneralInformationIsComplete = (
  profile?: ProfileProps,
): boolean => {
  if (!profile) return false

  const { name, email, phone, legalRepresentative, paymentsRepresentative } =
    profile

  const isCompleteProfile = Boolean(name && email && phone)
  const isCompleteLegalRepresentative = isValidContact(legalRepresentative)
  const isCompletePaymentsRepresentative = isValidContact(
    paymentsRepresentative,
  )

  return (
    isCompleteProfile &&
    isCompleteLegalRepresentative &&
    isCompletePaymentsRepresentative
  )
}

export const checkIfTaxSituationIsComplete = (profile?: ProfileProps) => {
  if (!profile) return false

  const { attributes } = profile

  return !!attributes?.cfdiUsage && !!attributes?.preferredPaymentPlanType
}

export const checkIfPaymentPreferencesIsComplete = (profile?: ProfileProps) => {
  if (!profile) return false

  const { financeProfile } = profile

  return (
    !!financeProfile?.enabledPaymentForms &&
    !!financeProfile?.enabledPaymentMethods &&
    financeProfile?.enabledPaymentForms.length > 0 &&
    financeProfile?.enabledPaymentMethods.length > 0
  )
}

export const checkIfProductsIndustryIsComplete = (
  lead: Partial<LeadProps> | undefined,
) => {
  if (!lead) return false

  return (
    !!lead?.productOfInterest &&
    !!lead?.industry &&
    !!lead?.companyManufacturedProduct
  )
}

export const checkIfConsumptionIsComplete = (
  lead: Partial<LeadProps> | undefined,
) => {
  if (!lead) return false

  return (
    !!lead?.monthlyBuyingPotential &&
    !!lead?.purchaseFrequency &&
    !!lead?.companyAge
  )
}

export const checkIfLogisticPreferencesIsComplete = (
  profile: Partial<ProfileProps> | undefined,
) => {
  if (!profile) return false

  return (
    !!profile?.selectedDeliveryPeriods &&
    !!profile?.selectedDeliveryDays &&
    profile?.selectedDeliveryPeriods.length > 0 &&
    profile?.selectedDeliveryDays.length > 0
  )
}
